import { jsx } from "react/jsx-runtime";
import { $createParagraphNode, $getSelection } from "lexical";
import { $createHeadingNode } from "@lexical/rich-text";
import { $setBlocksType } from "@lexical/selection";
import { MenuItem } from "../../../../../MenuItem/index.js";
import { Typography } from "../../../../../Typography/index.js";
const blockTypeToBlockName = {
    h5: 'Заголовок 1',
    h6: 'Заголовок 2',
    paragraph: 'Обычный текст'
};
const useTagsItems = (editor, activeTag)=>{
    const formatHeading = (headingSize)=>{
        editor.update(()=>{
            const selection = $getSelection();
            $setBlocksType(selection, ()=>$createHeadingNode(headingSize));
        });
    };
    const formatParagraph = ()=>{
        editor.update(()=>{
            const selection = $getSelection();
            $setBlocksType(selection, ()=>$createParagraphNode());
        });
    };
    const handleFormat = (value)=>{
        if ('paragraph' === value) formatParagraph();
        if ('h5' === value || 'h6' === value) formatHeading(value);
    };
    return Object.entries(blockTypeToBlockName).map(([tag, text])=>{
        let currentHeaderTag = 'h5';
        if ('h6' === tag) currentHeaderTag = 'h6';
        return /*#__PURE__*/ jsx(MenuItem, {
            onClick: ()=>handleFormat(tag),
            children: /*#__PURE__*/ jsx(Typography, {
                variant: 'paragraph' === tag ? 'body2' : currentHeaderTag,
                color: activeTag === tag ? 'original.brand.primary' : 'text.light.primary',
                children: text
            })
        }, tag);
    });
};
export { blockTypeToBlockName, useTagsItems };
